const PROJECT_MEMBERSHIP_ROLE_LABELS = {
  participant: "Participant",
  collaborator: "Collaborator",
  pi: "PI",
  admin: "Admin",
};

export const projectMembershipRoleLabel = role =>
  PROJECT_MEMBERSHIP_ROLE_LABELS[role] || role || "—";
